import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCompany } from "../../context/CompanyContext";
import { searchCrmRecords } from "../services/crmSearchService";

const CRMGlobalSearch = () => {
  const navigate = useNavigate();
  const { companyId } = useCompany();

  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [busy, setBusy] = useState(false);

  const runSearch = useCallback(async () => {
    if (!companyId || !query.trim()) {
      setResults([]);
      return;
    }

    setBusy(true);

    try {
      const rows = await searchCrmRecords(companyId, query);
      setResults(rows);
    } catch (error) {
      console.error(error.message);
      setResults([]);
    } finally {
      setBusy(false);
    }
  }, [companyId, query]);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      runSearch();
    }, 300);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [runSearch]);

  const handleOpen = useCallback(
    (route) => {
      setQuery("");
      setResults([]);
      navigate(route);
    },
    [navigate]
  );

  return (
    <div className="crm-global-search">
      <input
        className="crm-input"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        placeholder="Search leads, accounts, contacts, opportunities, quotes..."
      />

      {query.trim() ? (
        <div className="crm-global-search-results">
          {busy ? (
            <div className="crm-global-search-item">Searching...</div>
          ) : results.length === 0 ? (
            <div className="crm-global-search-item">No results found.</div>
          ) : (
            results.map((row) => (
              <button
                key={`${row.record_type}-${row.record_id}`}
                className="crm-global-search-item"
                onClick={() => handleOpen(row.route)}
              >
                <strong>{row.title || "Untitled"}</strong>
                <span>
                  {row.record_type} • {row.subtitle || "No details"}
                </span>
              </button>
            ))
          )}
        </div>
      ) : null}
    </div>
  );
};

export default CRMGlobalSearch;
